import { create } from 'zustand';

interface TaskReturnRevisionModalState {
  isOpen: boolean;
  taskId: number | string | null;
  isLocked: boolean;

  open: (taskId: number | string) => void;
  openLocked: (taskId: number | string) => void;

  close: () => void;

  lock: () => void;
  unlock: () => void;

  setTaskId: (taskId: number | string | null) => void;
}

export const useTaskReturnRevisionModalStore =
  create<TaskReturnRevisionModalState>((set) => ({
    isOpen: false,

    taskId: null,
    isLocked: false,

    open: (taskId) =>
      set({
        isOpen: true,
        taskId,
        isLocked: false,
      }),

    openLocked: (taskId) =>
      set({
        isOpen: true,
        taskId,
        isLocked: true,
      }),

    close: () =>
      set({
        isOpen: false,
        taskId: null,
        isLocked: false,
      }),

    lock: () => set({ isLocked: true }),
    unlock: () => set({ isLocked: false }),

    setTaskId: (taskId) => set({ taskId }),
  }));
